/** Created by azhou on 2019/2/15.*/
<template>
  <div :class="[type === 'textarea' ? 'd-start-center':'d-center']">
    <span v-if="leftText" :class="[required ? 'text-danger':'text-white','mr-small']">*</span>
    <div class="d-center" v-if="leftText"><div class="form-left-text" :style="{width:width+'px'}">{{leftText}}</div>
    <span class="text-dls">：</span>
  </div>
    <div class="input-self-border" v-if="type!=='textarea'" style="text-align:left;">
      <el-date-picker v-if="type=='date'"
        v-model="value2"
        type="date"
        @input="$emit('input',value2)"
        size="small"
        style="width:229px;"
        placeholder="选择日期">
      </el-date-picker>
      <el-date-picker
        v-model="value2"
        type="datetimerange"
        format='yyyy-MM-dd'     
        value-format='yyyy-MM-dd'    
        @input="$emit('input',value2)"
        range-separator="至"
        v-else-if="type=='daterange'"
        size="small"
        :picker-options="{selectableRange:`00:00:00 - ${value ? value +':00' : '23:59:00'}`}"
        style="width:229px;"
        start-placeholder="开始日期"
        end-placeholder="结束日期">
      </el-date-picker>
      <el-date-picker
          v-if="type=='month'"
          v-model="value2"
          type="month"
          @input="$emit('input',value2)"
          :style="{width:inputWidth+'px'}"
          class="month"
          size="small"
          placeholder="选择日期">
        </el-date-picker>
      <input :type="type" 
             :id="inputId"
             :class="appendText?'no-right':''"
             v-bind:value="value"
             :disabled="disabled"
             @input="$emit('input',$event.target.value)"
             @blur="$emit('blur',$event.target.value)"
             @keyup.enter="$emit('enter',$event.target.value)"
             :style="{width:inputWidth?inputWidth+'px':''}"
             v-else
             :placeholder="placeholder" />

      <div class="append" v-show="appendText">{{appendText}}</div>
    </div>
    <div class="d-center input-self-border" v-if="type==='textarea'">
      <textarea v-bind:value="insideValue" :disabled="disabled"
                @input="$emit('input',formatValue($event.target.value))"
                :placeholder="placeholder"></textarea>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'LeftTextBorder',
    props: {
      value: {},
       width: {
        type: Number,
        default:100
      },
      inputWidth:{
        type: Number,
        default:0
      },
      type: {
        type: String,
        default: 'text'
      },
      leftText: {
        type: String,
      },
      placeholder: {
        type: String,
      },
      required: {
        type: Boolean,
        default: false
      },
      inputId: {                       //input id，用作百度地图自动完成的id指向
        type: String,
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      },
      appendText: {}
    },
    data(){
      return {
        value2:''
      }
    },
    watch:{
      value(){
        this.value2=this.value
      }
    },
    mounted(){
      this.value2=this.value

    },
    computed:{
      //显示textarea中的换行空格符号
      insideValue() {
        if (this.value) return this.value.replace(/<br\/>/g, '\r\n').replace(/<br\/>/g, '\n').replace(/' '/g, '\s');
        return '';
      }
    },
    methods:{
      // 保存textarea中的换行空格符号
      formatValue(value) {
        return value.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>').replace(/\s/g, ' ');
      }
    }
  }
</script>
<style lang="scss" scoped>
  .narrow{
    input{
      height: 24px!important;
    }
  }
  .smallInput{
    height: 24px!important;
    line-height: 24px!important
  }
  .input-self-border {
    width: 100%;
    box-sizing: border-box;
    color: #606266;
    flex: 1;
    input,textarea{
      border: 1px solid #dcdfe6;
      padding: 3px 0px;
      appearance: none;
      width: 94%;
      padding: 0 3%;
      border-radius: 3px;
      font-size: 14px;
      line-height: 32px;
      &:focus{
        outline: none;
        border: 1px solid #26a2ff;
      }
    }
    input{height: 31px;}
    textarea{
      height: 80px;
      resize: none;
    }
  }
  .append{
    background-color: #f5f7fa;
    vertical-align: middle;
    display: table-cell;
    position: relative;
    border: 1px solid #dcdfe6;
    border-left: 0;
    font-size: 14px;
    padding: 3px 0;
    border-radius: 4px;
    width: 60px;
    white-space: nowrap;
    height: 24px;
    line-height: 24px;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    text-align: center
  }
  .month {
    width: 263px !important;
  }
</style>

